export class Address {

  id: number;
  name: string;
  user_id: number;
  address: string;
  description: string;
  latitude: string;
  longitude: string;
  priority: number;
  status: number;
  selected: boolean;
  action: boolean;

	constructor( a ?: any) {
    this.id = a ? a.id : null;
    this.name = a ? a.name : null;
		this.user_id = a ? a.user_id : null;
    this.address = a ? a.address : null;
    this.description = a ? a.description : null;
    this.latitude = a ? a.latitude : null;
    this.longitude = a ? a.longitude : null;
    this.priority = a ? a.priority : null;
    this.status = a ? a.status : null;
    this.selected = false;
    this.action = false;
  }
  
  mapAddress(list: any[]): Address[] {
    let newList: Address[] = [];
    list.forEach((item: any) => {
      let newItem: Address = new Address(item);
      newList.push(newItem);
    });
    return newList;
  }

}
